<template>
  <div class="yhc-service-level-delivery-date">
    <div class="yhc-service-level-delivery-date__title">
      <a
        href="#"
        class="hover-fade"
        ref="deliveryDateDisplay"
        @click.prevent="() => (showDateSelectPopover = !showDateSelectPopover)"
      >
        <ficon
          type="calendar"
          style="font-size: 1.2em"
        />
        お届け日を選択
      </a>
      <b-popover
        :target="() => $refs.deliveryDateDisplay"
        ref="deliveryDatePopover"
        hide-footer
        v-model="showDateSelectPopover"
        placement="bottom"
        custom-class="popover-body-no-padding"
        :manual="true"
        title=""
      >
        <datepicker
          class="border-0"
          :model-value="deliverySelectedDateOrToday"
          @update:model-value="onDateSelected"
          :inline="true"
          :disabled-dates="disabledDates"
        />
      </b-popover>
    </div>
    <div class="yhc-service-level-delivery-date__content">
      <div class="yhc-service-level-delivery-date__date">
        {{ deliveryDateDisplayLabel }}
      </div>
      <!-- お届け先変更でクリアされた場合に再選択を促す（お預かり日選択と同様） -->
      <div
        v-if="$yhcefs.$userInputData.deliveryDateResetFlag"
        class="delivery-date-warning"
      >
        ※お届け日を選択してください
      </div>
      <!-- 過去日を選択している場合に注釈を表示 -->
      <div
        v-if="isPastDeliveryDateSelected"
        class="delivery-date-warning"
      >
        ※過去日を選択しています。
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { YhcEstimateFormFrontService } from '../../YhcEstimateFormFrontPage/YhcEstimateFormFrontService'
import { formatDateWithWeekday } from '../utils/dateFormatter'

export default {
  name: 'YhcServiceLevelDeliveryDate',
  inject: ['YhcEstimateFormFrontServiceInstance'],
  data() {
    return {
      showDateSelectPopover: false,
    }
  },
  computed: {
    $yhcefs(): YhcEstimateFormFrontService {
      return this.YhcEstimateFormFrontServiceInstance
    },
    deliverySelectedDateOrToday(): string {
      const d = this.$yhcefs.$userInputData.deliverySelectedDate
      if (d) return d
      return $core.$dayjs().format('YYYY-MM-DD')
    },
    deliveryDateDisplayLabel(): string {
      const u = this.$yhcefs.$userInputData
      const d = u.deliverySelectedDate
      if (!d || u.deliveryDateResetFlag) return '----年--月--日'
      return formatDateWithWeekday(d)
    },
    /** 最短お届け日（今日以降の最初のお届け先営業日） */
    minDeliveryDate(): string {
      const uid = this.$yhcefs.$userInputData
      void this.$yhcefs.masterVersionPeriods
      void uid.toWorkingDayPatternByVersionId
      void uid.regularWorkingDayRecords
      void uid.fixed_holidays
      let current = $core.$dayjs()
      for (let i = 0; i < 31; i++) {
        const dateStr = current.format('YYYY-MM-DD')
        if (uid.isDeliveryWorkingDayForDate(dateStr)) {
          return dateStr
        }
        current = current.add(1, 'day')
      }
      return $core.$dayjs().format('YYYY-MM-DD')
    },
    /** 過去日（最短お届け日より前）を選択しているか */
    isPastDeliveryDateSelected(): boolean {
      const d = this.$yhcefs.$userInputData.deliverySelectedDate
      if (!d) return false
      return $core.$dayjs(d).isBefore($core.$dayjs(this.minDeliveryDate), 'day')
    },
    /** お届け先の営業曜日・固定休日に基づき選択不可日を返す（営業日でない日を disable） */
    disabledDates() {
      const uid = this.$yhcefs.$userInputData
      void this.$yhcefs.masterVersionPeriods
      void uid.toWorkingDayPatternByVersionId
      void uid.regularWorkingDayRecords
      void uid.fixed_holidays
      void this.$yhcefs.isFleaMarket
      return (date) => uid.isDeliveryCalendarDateDisabled(date)
    },
  },
  methods: {
    async onDateSelected(value: string | Date | null) {
      this.$yhcefs.$userInputData.deliverySelectedDate = value
        ? $core.$dayjs(value).format('YYYY-MM-DD')
        : null
      this.$yhcefs.$userInputData.deliveryDateResetFlag = false
      await this.$yhcefs.$userInputData.refreshMastersForSelectedDates()
      this.showDateSelectPopover = false
    },
  },
}
</script>

<style lang="scss" scoped>
.yhc-service-level-delivery-date {
  padding: 8px 16px;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 1px 1px 8px rgba(0, 0, 0, 0.15);
  box-sizing: border-box;

  &__title {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 4px;
    color: var(--yhc-color);
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  &__date {
    font-size: 16px;
    font-weight: 500;
    word-wrap: break-word;
  }

  .delivery-date-warning {
    color: red;
    font-size: 14px;
    margin-top: 5px;
  }

  @media screen and (max-width: 767px) {
    padding: 6px 10px;
    width: 100%;

    &__title {
      font-size: 16px;
      margin-bottom: 6px;
    }

    &__date {
      font-size: 15px;
      word-break: break-word;
    }
  }
}
</style>
